import type { ChangelogEntry } from "../types";

/**
 * Tre feil Erik fant i smoke-testen etter v2-lanseringen. Rapporter-feilen
 * rammet bare admin-flaten (faktureringsgrad og kapasitet), og slettingen i
 * dokumentarkivet bare dem som har flagget, så de to punktene er avgrenset.
 * Slettepunktet har ikke rollekrav: hvem som kan slette styres per mappe.
 */
export const SMOKE_FIKSER_2026_10: ChangelogEntry = {
  id: "2026-10-01-smoke-fikser",
  date: "2026-10-01",
  title: "Rapporter viser tall igjen",
  summary:
    "Faktureringsgrad og kapasitet under Rapporter viste «Ingen data». Det er rettet, sammen med sletting i dokumentarkivet og «Hopp til innhold».",
  sections: [
    {
      heading: "Rapporter",
      minRole: "admin",
      items: [
        {
          title: "Faktureringsgrad og kapasitet viser tall igjen",
          kind: "rettet",
          body: "Begge rapportene sto tomme med «Ingen data» selv om tallene fantes. Nå vises de per ansatt for perioden du velger, som før.",
        },
      ],
    },
    {
      heading: "Dokumenter",
      items: [
        {
          title: "Du kan slette dokumenter og mapper",
          kind: "rettet",
          body: "Sletting stoppet med en feilmelding om tilgang, også for dem som har lov til å slette. Nå forsvinner dokumentet fra lista, og fila er ikke lenger tilgjengelig.",
          featureFlag: "feature_dokumentarkiv",
        },
      ],
    },
    {
      heading: "Tastatur",
      items: [
        {
          title: "«Hopp til innhold» viser hvor du havnet",
          kind: "rettet",
          body: "Når du hopper forbi menyen med tastaturet, får innholdet en tydelig ramme, så du ser at du står i selve siden.",
        },
      ],
    },
  ],
};
